import { Form, Formik } from "formik";
import React, { useEffect, useRef, useState } from "react";
import { toast } from "react-toastify";
import styled from "styled-components";
import users from "../../apiConfigs/users";
import { ReactComponent as Upload } from "../../assets/upload.svg";
import { useRoot } from "../../context/RootProvider";
import Button from "../../designComponents/Button";
import LabelInputField from "../../designComponents/LabelInputField/LabelInputField";
import Typography from "../../designComponents/Typography";
import requestAPI from "../../utils/requestAPI";
import { uploadFilesToS3OnlyKeys } from "../../utils/s3Upload";
import {
  AcceptButton,
  ButtonsSection,
  RejectButton,
  SectionTitle,
  Title,
  Wrapper,
} from "../Properties/Details/styles";
import { resizeImage } from "../../utils/resizeImages";

type Props = {};

const ProfileWrapperStyled = styled.div`
  display: flex;
  flex-direction: column;
  gap: 40px;
  padding: 20px;
`;

const Profile = (props: Props) => {
  const fileInputRef = useRef<HTMLInputElement | null>(null);
  const { auth, setAuth } = useRoot();
  const [isEditable, setIsEditable] = useState(false);
  const handleImageChange = async (
    event: React.ChangeEvent<HTMLInputElement>
  ) => {
    const file = event.target.files ? event.target.files[0] : null;
    console.log("uploadFiles", file);
    let providedUrl: string = "";
    if (file) {
      try {
        const uploadFiles = await uploadFilesToS3OnlyKeys({
          category: "avatar",
          fileUri: [file],
          userId: auth?._id ?? "",
        });
        if (uploadFiles && uploadFiles?.length > 0) {
          providedUrl = uploadFiles[0];
        }

        await requestAPI(
          users.updateAdmin(
            {
              avatar: providedUrl,
              firstName: auth?.firstName,
              lastName: auth?.lastName,
              phone: "989898",
              email: auth?.email ?? "",
              address: "north",
            },
            auth?._id ?? ""
          )
        );

        setAuth({
          _id: auth?._id ?? "",
          avatar: providedUrl,
          firstName: auth?.firstName ?? "",
          lastName: auth?.lastName ?? "",
          email: auth?.email ?? "",
          role: auth?.role ?? "OPERATOR",
        });
        toast.success(`Profile picture saved`);
      } catch (error: any) {
        toast.error(error.message);
      }
    }
  };
  const handleUploadClick = () => {
    if (fileInputRef.current) {
      fileInputRef.current.click(); // Trigger the file input dialog
    }
  };
  const initialValues = {
    firstName: auth?.firstName || "",
    lastName: auth?.lastName || "",
  };

  const handleEditClick = () => {
    setIsEditable(true);
  };

  const handleSave = async (values: any) => {
    try {
      const response = await requestAPI(
        users.updateAdmin(values, auth?._id ?? "")
      );
      console.log(response);
      setAuth(response);
      toast.success("Profile Updated Successfully");
    } catch (error: any) {
      console.log(error.message);
    }
    setIsEditable(false);
  };
  console.log(auth?.avatar);

  return (
    <Wrapper>
      <Title>Profile</Title>
      <div>
        <div style={{ display: "flex", gap: 20 }}>
          <img
            src={resizeImage(auth?.avatar + `?${Date.now()}`, "sm") ?? ""}
            alt="profile"
            height={90}
            width={90}
            style={{ borderRadius: "50%", objectFit: "cover" }}
          />
          <div style={{ display: "flex", flexDirection: "column", gap: 10 }}>
            <input
              ref={fileInputRef}
              type="file"
              accept="image/jpeg"
              style={{ display: "none" }}
              onChange={handleImageChange}
            />
            <SectionTitle style={{ color: "#3F3F3F" }}>
              Profile Picture
            </SectionTitle>
            <ButtonsSection>
              <AcceptButton
                onClick={handleUploadClick}
                icon={<Upload fill="#fff" />}
              >
                Upload Image
              </AcceptButton>
              <RejectButton>Remove</RejectButton>
            </ButtonsSection>
            <Typography size="caption" style={{ color: "#5f5f5f" }}>
              We support PNGs and JPEGs
            </Typography>
          </div>
        </div>

        <Formik initialValues={initialValues} onSubmit={handleSave}>
          {({ values, handleChange, handleBlur }) => (
            <Form>
              <div
                style={{
                  display: "flex",
                  flexDirection: "column",
                  gap: "10px",
                  paddingTop: 20,
                }}
              >
                <div
                  style={{ display: "flex", justifyContent: "space-between" }}
                >
                  <SectionTitle>Profile Information</SectionTitle>
                  {!isEditable ? (
                    <div onClick={handleEditClick}>
                      <Typography
                        style={{ color: "#003DA8", cursor: "pointer" }}
                      >
                        Edit Information
                      </Typography>
                    </div>
                  ) : (
                    <Button
                      type="submit"
                      style={{ backgroundColor: "#003DA8", height: 34 }}
                    >
                      Save Information
                    </Button>
                  )}
                </div>

                <div style={{ display: "flex", width: "100%" }}>
                  <div style={{ flex: 1, paddingRight: "8px" }}>
                    <LabelInputField
                      style={{
                        label: {
                          fontSize: "14px",
                          fontWeight: "600",
                          color: "#555A77",
                        },
                        input: {
                          height: 50,
                          border: "1px solid #E3DFF6",
                          padding: 8,
                          background: "#F9F9FD",
                          borderRadius: 6,
                          width: "100%",
                        },
                        container: {
                          display: "flex",
                          flexDirection: "column",
                          gap: 6,
                          paddingTop: 14,
                        },
                      }}
                      name="firstName"
                      label="First name"
                      value={values.firstName}
                      onChange={handleChange}
                      onBlur={handleBlur}
                      disabled={!isEditable}
                    />
                  </div>
                  <div style={{ flex: 1, paddingLeft: "8px" }}>
                    <LabelInputField
                      style={{
                        label: {
                          fontSize: "14px",
                          fontWeight: "600",
                          color: "#555A77",
                        },
                        input: {
                          height: 50,
                          border: "1px solid #E3DFF6",
                          padding: 8,
                          background: "#F9F9FD",
                          borderRadius: 6,
                          width: "100%",
                        },
                        container: {
                          display: "flex",
                          flexDirection: "column",
                          gap: 6,
                          paddingTop: 14,
                        },
                      }}
                      name="lastName"
                      label="Last name"
                      value={values.lastName}
                      onChange={handleChange}
                      onBlur={handleBlur}
                      disabled={!isEditable}
                    />
                  </div>
                </div>

                <div style={{ display: "flex", width: "100%" }}></div>
              </div>
            </Form>
          )}
        </Formik>
      </div>
    </Wrapper>
  );
};

export default Profile;
